const Widget = ({ title, children }) => {
  return ( 
    <div className="bx mb">
      <h3>{title}</h3>
      {children}
    </div>
  );
}

export default Widget;